import { HttpClient } from '@angular/common/http';
import {
  TRANSLOCO_LOADER,
  Translation,
  TranslocoLoader,
  TRANSLOCO_CONFIG,
  translocoConfig,
  TranslocoModule,
  TranslocoService
} from '@ngneat/transloco';
import { APP_INITIALIZER, Injectable, NgModule } from '@angular/core';
import { getLanguage, initializeTranslations } from './translation.initializer';
import { environment } from '@env/environment';
import { TranslationPipe } from './translation.pipe';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}

@NgModule({
  declarations: [TranslationPipe],
  exports: [TranslocoModule, TranslationPipe],
  providers: [
    TranslationPipe,
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig({
        availableLangs: ['de', 'en'],
        defaultLang: getLanguage(),
        // Remove this option if your application doesn't support changing language in runtime.
        fallbackLang: 'de',
        reRenderOnLangChange: true,
        prodMode: environment.production
      })
    },
    { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader },
    { provide: APP_INITIALIZER, useFactory: initializeTranslations, multi: true, deps: [TranslocoService] }
  ]
})
export class TranslationModule {}
